// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CompanyDepartmentsPage_pageWrapper__3R_b6"};